var ProgressBar = function(props) {
  var { completed } = props;
  if (!isNaN(completed)) {
    return (
      <div className='progressBarContainer'>
        <div className='progressBarFiller' style={{ width: `${completed}%` }}>
          <span className='progressBarLabels'>{`${completed}%`}</span>
        </div>
      </div>
    );
  } else {
    return null;
  }
};

module.exports = ProgressBar;


// WEBPACK FOOTER //
// ./modules/components/users/students/ProgressBar.js